import {
  DRAWERS_PANEL_WIDTH,
  TOP_BAR_HEIGHT,
} from './DrawersPanel.constants.js';

const StyledDrawerPanel = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={`fixed right-0 z-sticky flex h-full flex-col items-center border-l border-l-ui-tertiary bg-ui-primary pt-4`}
      style={{
        top: `${TOP_BAR_HEIGHT}px`,
        width: `${DRAWERS_PANEL_WIDTH}px`,
      }}
    >
      {children}
    </div>
  );
};

export default StyledDrawerPanel;
